

export default function ErrorElementBackEnd() {
    return <>
        <div className="container body-text">
            <h1>There was an issue getting data from the events surver. Please try again later.</h1>
        </div>
    </>
}